module.exports = __webpack_public_path__ + "img/Sustainable3.5603bb36.jpg";